import * as yup from 'yup';
import {
  hasVorschadenElementar,
  hasVorschadenFeuerBlitz,
  hasVorschadenGlas,
  hasVorschadenLeitungswasser,
  hasVorschadenSonstige,
  hasVorschadenSturmHagel,
  showVorschadenElementar,
  showVorschadenGlasversicherung,
} from '@/features/Sparten/woh/formConfigs/sharedRenderConditions';
import { isDateAfterBaujahr } from '@/features/Sparten/woh/schema/helper';
import { getCurrentYear } from '@/utils/dates/dates';
import { useWohInputStore } from '@/features/Sparten/woh/useInputStore';

const damageYearRequiredSchema = yup
  .number()
  .required()
  .max(getCurrentYear())
  .test(isDateAfterBaujahr);

export const vorschaedenSchema = yup
  .object({
    leitungswasser: yup.boolean().required().default(false),
    leitungswasserAnzahl: yup
      .number()
      .default(0)
      .when({
        is: () => hasVorschadenLeitungswasser(),
        then: yup.number().required().min(1),
      }),
    leitungswasserJahr: yup
      .number()
      .default(0)
      .when({
        is: () => hasVorschadenLeitungswasser(),
        then: damageYearRequiredSchema,
      }),
    sturmHagel: yup.boolean().required().default(false),
    sturmHagelAnzahl: yup
      .number()
      .default(0)
      .when({
        is: () => hasVorschadenSturmHagel(),
        then: yup.number().required().min(1),
      }),
    sturmHagelJahr: yup
      .number()
      .default(0)
      .when({
        is: () => hasVorschadenSturmHagel(),
        then: damageYearRequiredSchema,
      }),
    feuerBlitz: yup.boolean().required().default(false),
    feuerBlitzAnzahl: yup
      .number()
      .default(0)
      .when({
        is: () => hasVorschadenFeuerBlitz(),
        then: yup.number().required().min(1),
      }),
    feuerBlitzJahr: yup
      .number()
      .default(0)
      .when({
        is: () => hasVorschadenFeuerBlitz(),
        then: damageYearRequiredSchema,
      }),
    elementar: yup
      .boolean()
      .default(false)
      .when({
        is: () => showVorschadenElementar(),
        then: yup.boolean().required(),
      }),
    elementarAnzahl: yup
      .number()
      .default(0)
      .when({
        is: () => hasVorschadenElementar(),
        then: yup.number().required().min(1),
      }),
    elementarJahr: yup
      .number()
      .default(0)
      .when({
        is: () => hasVorschadenElementar(),
        then: damageYearRequiredSchema,
      }),
    glas: yup
      .boolean()
      .default(false)
      .when({
        is: () => showVorschadenGlasversicherung(),
        then: yup.boolean().required(),
      }),
    glasAnzahl: yup
      .number()
      .default(0)
      .when({
        is: () => hasVorschadenGlas(),
        then: yup.number().required().min(1),
      }),
    glasJahr: yup
      .number()
      .default(0)
      .when({
        is: () => hasVorschadenGlas(),
        then: damageYearRequiredSchema,
      }),
    sonstige: yup.boolean().required().default(false),
    sonstigeAnzahl: yup
      .number()
      .default(0)
      .when({
        is: () => hasVorschadenSonstige(),
        then: yup.number().required().min(1),
      }),
  })
  .test({
    name: 'isRequired',
    message: () => {
      const parts = ['Leitungswasser', 'Sturm & Hagel', 'Feuer & Blitz'];

      if (useWohInputStore().absicherungen.glasversicherung) {
        parts.push('Glas');
      }

      if (useWohInputStore().absicherungen.elementar) {
        parts.push('Elementar');
      }

      return `Bitte wählen Sie mindestens eines der Optionen ${parts.join(', ')} oder Sonstige aus.`;
    },
    test(value) {
      if (!useWohInputStore().vorschaden) return true;

      if (
        useWohInputStore().absicherungen.glasversicherung ||
        useWohInputStore().absicherungen.elementar
      ) {
        return (
          value.leitungswasser ||
          value.sturmHagel ||
          value.feuerBlitz ||
          value.sonstige ||
          value.glas ||
          value.elementar
        );
      }

      return (
        value.leitungswasser ||
        value.sturmHagel ||
        value.feuerBlitz ||
        value.sonstige
      );
    },
  });
